import { Component } from '@angular/core';
import { DroneModelBaseComponent } from '../drone-model-base';

@Component({
  selector: 'app-drone-model-vector',
  templateUrl: './drone-model-vector.component.html',
  styleUrl: './drone-model-vector.component.scss',
  standalone: false,
})
export class DroneModelVectorComponent extends DroneModelBaseComponent {
  getConfigurationType(): string[] {
    return ['vectorR24', 'vectorR25'];
  }
}
